import * as tslib_1 from "tslib";
import _ from 'lodash';
import { cartIconTranslationPath, POPUP_URL, EMPTY_CART_GUID, CART_ICON_APP_NAME } from '../constants';
import { ProductType } from '@wix/wixstores-client-core/dist/es/src/types/product';
import { CartType } from '@wix/wixstores-client-core/dist/es/src/types/cart';
import { CartActions } from '@wix/wixstores-client-core/dist/es/src/cart-actions/cartActions';
import { create } from '@wix/fedops-logger';
import { getTranslations, translate, isWorker } from '@wix/wixstores-client-core/dist/es/src/viewer-script/utils';
import { PubSubManager } from '@wix/wixstores-client-core/dist/es/src/pub-sub-manager/pubSubManager';
import { newCartToOldCartStructure } from '@wix/wixstores-client-core/dist/es/src/common/cart-services/cart-services';
import { Topology, PageMap } from '@wix/wixstores-client-core/dist/src/constants';
import { StoresWidgetID, APP_DEFINITION_ID } from '@wix/wixstores-client-core/dist/es/src/constants';
import { query } from '../graphql/getData.graphql';
import { query as getAppSettingsData } from '../graphql/getAppSettingsData.graphql';
import { getLocaleNamespace } from '@wix/wixstores-client-core/dist/es/src/getLocaleNamespace';
var CartStore = /** @class */ (function () {
    function CartStore(siteStore, config, compId, setProps, reportError, platformAPIs) {
        var _this = this;
        this.siteStore = siteStore;
        this.config = config;
        this.compId = compId;
        this.setProps = setProps;
        this.reportError = reportError;
        this.translations = {};
        this.isStartReported = false;
        this.onFocusTriggered = function () {
            _this.setProps({
                triggerFocus: false,
            });
        };
        this.onAppLoaded = function () {
            if (!isWorker() || (_this.siteStore.isInteractive() && _this.isStartReported)) {
                _this.fedopsLogger.appLoaded();
            }
        };
        this.openPopup = function () {
            var popupUrl = POPUP_URL;
            if (_this.config.externalId) {
                popupUrl += "?externalId=" + _this.config.externalId;
            }
            _this.siteStore.windowApis.openPersistentPopup(
            // tslint:disable-line no-floating-promises
            popupUrl, {
                theme: 'BARE',
                width: '0%',
                height: '100%',
                position: {
                    origin: 'FIXED',
                    placement: 'TOP_RIGHT',
                    x: 0,
                    y: 0,
                },
            }, _this.compId);
            _this.pubSubManager.publish('Minicart.isExist', true, true);
        };
        this.onIconClick = function () {
            var cartId = _this.cart.cartId === EMPTY_CART_GUID ? '' : _this.cart.cartId;
            var partialBi = {
                cartId: cartId || '',
                cartType: _this.getCartType(),
                itemsCount: _this.getTotalQuantity(_this.cart.items),
                viewMode: _this.siteStore.viewMode.toLowerCase(),
            };
            if (_this.isOpenPopup()) {
                _this.pubSubManager.publish('Minicart.Toggle', null, false);
                var eventId_1 = _this.pubSubManager.subscribe('Minicart.DidClose', function () {
                    _this.setProps({
                        triggerFocus: true,
                    });
                    _this.pubSubManager.unsubscribe('Minicart.DidClose', eventId_1);
                });
                //tslint:disable-next-line:no-floating-promises
                _this.siteStore.biLogger.clickOnCartIconToOpenMiniCartSf(tslib_1.__assign({}, partialBi, { isNavigateCart: false }));
            }
            else {
                var origin_1 = 'cart-icon';
                //tslint:disable-next-line:no-floating-promises
                _this.siteStore.biLogger.clickToViewCartPageSf(tslib_1.__assign({}, partialBi, { origin: origin_1, isNavigateCart: true }));
                _this.cartActions.navigateToCart(origin_1);
            }
        };
        this.initPopup = function () {
            _this.listenLoadedMinicartPopupAndSendCart();
            _this.openPopup();
        };
        this.pubSubManager = new PubSubManager(this.siteStore.pubSub);
        this.cartActions = new CartActions(this.siteStore, this.pubSubManager, 'wixcode', PageMap.CART);
        if (!this.siteStore.isEditorMode()) {
            this.registerEvents();
            this.registerWixCode();
        }
        else {
            window.onunload = function () { return _this.pubSubManager.publish('Minicart.isExist', false, true); };
        }
        var fedopsAppName = "" + CART_ICON_APP_NAME + (isWorker() ? '-ooi' : '');
        if (isWorker()) {
            this.fedopsLogger = create(fedopsAppName, {
                isWidgetLogger: true,
                isServerSide: this.siteStore.isSSR(),
                appId: APP_DEFINITION_ID,
                metasiteId: this.siteStore.msid,
                widgetId: StoresWidgetID.CART_ICON,
            });
            var sessionKey = compId + "_instance";
            if (platformAPIs.storage.session.getItem(sessionKey) !== this.siteStore.instance) {
                this.fedopsLogger.appLoadStarted();
                this.isStartReported = true;
                platformAPIs.storage.session.setItem(sessionKey, this.siteStore.instance);
            }
        }
        else {
            this.fedopsLogger = create(fedopsAppName);
        }
    }
    CartStore.prototype.registerWixCode = function () {
        var _this = this;
        this.pubSubManager.subscribe("Wixcode.AddToCart_" + this.compId, function (_a) {
            var data = _a.data;
            return _this.addToCart(data.productId, data.quantity, data.options)
                .then(function () { return _this.pubSubManager.publish("Wixcode.AddToCart.Added_" + _this.compId, { isResolve: true }); })
                .catch(function () { return _this.pubSubManager.publish("Wixcode.AddToCart.Added_" + _this.compId, { isResolve: false }); });
        });
    };
    CartStore.prototype.updateCart = function (cart) {
        this.cart = cart;
        var count = this.getTotalQuantity(this.cart.items);
        this.setProps(tslib_1.__assign({}, this.getCountRelatedProps(count)));
    };
    CartStore.prototype.registerEvents = function () {
        var _this = this;
        this.pubSubManager.subscribe('Cart.Cleared', function () {
            _this.updateCart({ items: [] });
        });
        this.pubSubManager.subscribe('Cart.Changed', function (res) {
            _this.updateCart(res.data);
        });
        if (!this.siteStore.isMobile()) {
            setTimeout(this.initPopup, 0);
        }
    };
    CartStore.prototype.setInitialState = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, Promise.all([
                        this.siteStore.experiments &&
                            this.siteStore.experiments.enabled('specs.stores.RemoveCartCounterFromSSR') &&
                            this.siteStore.isSSR()
                            ? this.getAppSettingsData()
                            : this.getData(),
                        getTranslations(cartIconTranslationPath(this.siteStore.baseUrls.cartIconBaseUrl, this.siteStore.locale)),
                        this.siteStore.getSectionUrl(PageMap.CART),
                    ])
                        .then(function (_a) {
                        var serverResponse = _a[0], translationsResponse = _a[1], cartLink = _a[2];
                        _this.cart = serverResponse.cartSummary || {};
                        _this.translations = translationsResponse;
                        var count = _this.cart.items ? _this.getTotalQuantity(_this.cart.items) : 0;
                        var props = tslib_1.__assign({}, _this.getCountRelatedProps(count), { cartLink: _.get(cartLink, 'url', ''), isInteractive: _this.siteStore.isInteractive(), isLoaded: true, displayText: _this.getDisplayText(serverResponse.widgetSettings), triggerFocus: false, onFocusTriggered: _this.onFocusTriggered, isNavigate: !_this.isOpenPopup(), onIconClick: _this.onIconClick, onAppLoaded: _this.onAppLoaded, cssBaseUrl: _this.siteStore.baseUrls.cartIconBaseUrl, ravenUserContextOverrides: {
                                id: _this.siteStore.storeId,
                            } });
                        _this.setProps(props);
                    })
                        .then(function () {
                        if (_this.siteStore.isSSR()) {
                            _this.fedopsLogger.appLoaded();
                        }
                    })
                        .catch(this.reportError)];
            });
        });
    };
    CartStore.prototype.getDisplayText = function (widgetSettings) {
        var defaultValue = this.translations["CART_ICON_" + this.config.style.styleParams.numbers.cartWidgetIcon];
        var widgetSettingsForLocale = {};
        if (this.siteStore.getMultiLangFields() &&
            !this.siteStore.getMultiLangFields().isPrimaryLanguage &&
            widgetSettings) {
            widgetSettingsForLocale = widgetSettings[getLocaleNamespace(this.siteStore.getMultiLangFields().lang)];
            return _.get(widgetSettingsForLocale, 'CART_ICON_TEXT', '') || defaultValue;
        }
        return _.get(this.config, 'publicData.APP.CART_ICON_TEXT', '') || defaultValue;
    };
    CartStore.prototype.getData = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var postData;
            return tslib_1.__generator(this, function (_a) {
                if (this.cartPromise) {
                    return [2 /*return*/, this.cartPromise];
                }
                postData = {
                    query: query,
                    source: 'WixStoresWebClient',
                    operationName: 'getCartService',
                    variables: { externalId: this.config.externalId || '' },
                };
                this.cartPromise = this.siteStore.httpClient
                    .post(this.siteStore.resolveAbsoluteUrl("/" + Topology.READ_WRITE_GRAPHQL_URL), postData)
                    .then(function (_a) {
                    var data = _a.data;
                    return {
                        cartSummary: newCartToOldCartStructure(data.cartService.cart),
                        widgetSettings: _.get(data, 'appSettings.widgetSettings', {}),
                    };
                });
                return [2 /*return*/, this.cartPromise];
            });
        });
    };
    CartStore.prototype.getAppSettingsData = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var postData;
            return tslib_1.__generator(this, function (_a) {
                if (this.appSettingsPromise) {
                    return [2 /*return*/, this.appSettingsPromise];
                }
                postData = {
                    query: getAppSettingsData,
                    source: 'WixStoresWebClient',
                    operationName: 'getAppSettings',
                    variables: { externalId: this.config.externalId || '' },
                };
                this.appSettingsPromise = this.siteStore.httpClient
                    .post(this.siteStore.resolveAbsoluteUrl("/" + Topology.STOREFRONT_GRAPHQL_URL), postData)
                    .then(function (_a) {
                    var data = _a.data;
                    return {
                        widgetSettings: _.get(data, 'appSettings.widgetSettings', {}),
                    };
                });
                return [2 /*return*/, this.appSettingsPromise];
            });
        });
    };
    CartStore.prototype.isOpenPopup = function () {
        return ((!this.config.style.styleParams.numbers.iconLink || this.config.style.styleParams.numbers.iconLink === 2) &&
            !this.siteStore.isMobile());
    };
    CartStore.prototype.listenLoadedMinicartPopupAndSendCart = function () {
        var _this = this;
        this.pubSubManager.subscribe('Minicart.LoadedWithoutData', function () {
            return _this.getData().then(function (cart) {
                _this.pubSubManager.publish('Minicart.OnInitialData', cart.cartSummary);
                _this.cart = cart.cartSummary;
            });
        }, true);
    };
    CartStore.prototype.addToCart = function (productId, quantity, options) {
        if (options === void 0) { options = {}; }
        if (!productId) {
            return Promise.reject();
        }
        var customTextFields = options.customTextFields &&
            options.customTextFields.map(function (_a) {
                var title = _a.title, value = _a.value;
                return ({
                    customText: {
                        title: title,
                    },
                    answer: value,
                });
            });
        return this.cartActions
            .addToCart(productId, options.choices || {}, quantity === undefined ? 1 : quantity, customTextFields)
            .then(function () { return true; });
    };
    CartStore.prototype.unSubscribeAll = function () {
        return this.pubSubManager.unsubscribeAll();
    };
    CartStore.prototype.getCartType = function () {
        var hasDigital = this.cart.items.some(function (item) { return item.productType === ProductType.DIGITAL; });
        var hasPhysical = this.cart.items.some(function (item) { return !item.productType || item.productType === ProductType.PHYSICAL; });
        if (hasDigital && hasPhysical) {
            return CartType.MIXED;
        }
        else if (hasDigital) {
            return CartType.DIGITAL;
        }
        else {
            return CartType.PHYSICAL;
        }
    };
    CartStore.prototype.getTotalQuantity = function (cartItems) {
        if (cartItems === void 0) { cartItems = []; }
        return cartItems.reduce(function (previousValue, currentValue) {
            return previousValue + (currentValue.quantity || 0);
        }, 0);
    };
    CartStore.prototype.getCountRelatedProps = function (count) {
        return {
            count: count,
            ariaLabelLink: translate(_.get(this.translations, 'sr.CART_WIDGET_BUTTON_TEXT', ''), {
                itemsCount: "" + count,
            }),
        };
    };
    return CartStore;
}());
export { CartStore };
//# sourceMappingURL=cartStore.js.map